import { normalizeCpf } from '../../SpreadsheetImportModal/utils/outcomeMapper';
export { extractOutcome, normalizeCpf } from '../../SpreadsheetImportModal/utils/outcomeMapper';
export function mapOrderSpreadsheetSuccessToValidatedRows(items) {
    return items.map((item, index) => {
        const fullName = `${item.firstName ?? ''} ${item.lastName ?? ''}`.trim();
        const document = item.document ?? '';
        const daysFromSheet = item.workingDays ?? item.daysQuantity ?? 0;
        return {
            rowIndex: index + 2,
            name: fullName,
            cpf: document,
            normalizedCpf: document ? normalizeCpf(document) : '',
            value: item.amount ?? 0,
            daysQuantity: daysFromSheet,
            discountValue: item.discountValue ?? item.discountPercentage ?? 0,
        };
    });
}
